import { jsx as _jsx } from "react/jsx-runtime";
import { EditAndCreateBase } from "$components/List/EditAndCreateBase";
const ListCreate = (props) => {
    return _jsx(EditAndCreateBase, { variantProps: props, variant: "create" });
};
export { ListCreate };
